
import { useState, useEffect } from "react";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { castId } from "@/integrations/supabase/helpers";

export const useVendorService = (id: string | undefined) => {
  const { toast } = useToast();
  const [loading, setLoading] = useState(true);
  const [serviceName, setServiceName] = useState("");
  const [serviceOwnerId, setServiceOwnerId] = useState<string | null>(null);
  const [serviceData, setServiceData] = useState<any>(null);

  useEffect(() => {
    const fetchService = async () => {
      console.log("[useVendorService] Starting with ID:", id);
      
      if (!id) {
        setLoading(false);
        return;
      }
      
      try {
        // Convert string id to number using parseInt, or use castId helper from supabase helpers
        const numericId = parseInt(id, 10);
        
        const { data: service, error } = await supabase
          .from('services')
          .select('*') // Select all fields to get complete service data
          .eq('id', numericId)
          .single();

        if (error) {
          console.error("[useVendorService] Error fetching service:", error);
          toast({
            variant: "destructive",
            title: "Error",
            description: "Failed to load service details",
          });
          setLoading(false);
          return;
        }

        if (service) {
          console.log("[useVendorService] Service found:", service.name);
          setServiceName(service.name);
          setServiceOwnerId(service.owner_id);
          setServiceData(service); // Store the full service data
        }
      } catch (error: any) {
        console.error("[useVendorService] Error:", error);
        toast({
          variant: "destructive",
          title: "Error",
          description: "Failed to load service details",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchService();
  }, [id, toast]);

  return { loading, serviceName, serviceOwnerId, serviceData };
};
